'use client';

import React from 'react';
import { Badge } from '@repo/ui/components/ui/badge';
import { EmptyValue } from './empty-value';
import { Field } from '../../../edit-inventaire/types';

interface TableValueProps {
  value: Record<string, string>;
  tableConfig: Field['tableConfig'];
}

export function TableValue({ value, tableConfig }: TableValueProps) {
  if (!value || typeof value !== 'object' || !tableConfig) {
    return <EmptyValue />;
  }

  const colsCount = tableConfig.cols.length;

  return (
    <div className="overflow-hidden rounded-lg border border-border/60 bg-card ring-1 ring-border/20 dark:border-border/80 dark:ring-border/30">
      <div
        className="grid gap-3 p-3"
        style={{ gridTemplateColumns: `1fr repeat(${colsCount}, 1fr)` }}
      >
        {/* Header row */}
        <div className="text-xs font-semibold uppercase tracking-wide text-muted-foreground/90 dark:text-muted-foreground/80"></div>
        {tableConfig.cols.map((col) => (
          <div
            key={col.id}
            className="text-center text-xs font-semibold uppercase tracking-wide text-muted-foreground/90 dark:text-muted-foreground/80"
          >
            {col.label}
          </div>
        ))}

        {/* Data rows */}
        {tableConfig.rows.map((row) => (
          <React.Fragment key={row}>
            <div className="text-xs font-semibold text-foreground">{row}</div>
            {tableConfig.cols.map((col) => {
              const isSelected = value[row] === col.id;
              return (
                <div key={col.id} className="flex justify-center">
                  <Badge
                    variant={isSelected ? 'default' : 'outline'}
                    className={`text-xs font-medium shadow-sm ${
                      isSelected
                        ? 'bg-primary text-primary-foreground'
                        : 'border-border/40 bg-muted/30 dark:border-border/30 dark:bg-muted/20'
                    }`}
                  >
                    {isSelected ? col.label : '-'}
                  </Badge>
                </div>
              );
            })}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}

